/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'heart': {
    width: 26,
    height: 24,
    viewBox: '0 0 26 24',
    data: '<path pid="0" d="M13 24l-1.82-1.826C4.42 16.174 0 12.13 0 7.174 0 3.13 3.12 0 7.15 0 9.36 0 11.57 1.043 13 2.74 14.43 1.042 16.64 0 18.85 0 22.88 0 26 3.13 26 7.174c0 4.956-4.42 9-11.18 15L13 24z" _fill="#000" fill-rule="nonzero" opacity=".06"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/heart.js